/**
 * Route guard — checks auth + role, redirects to /login if not authorized.
 */

import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface Props {
  role?: 'admin' | 'client';
}

export function RequireRole({ role }: Props) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0d0d0d', color: '#94a3b8' }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (role && user?.role !== role) {
    // Wrong role — redirect to their appropriate area
    return <Navigate to={user?.role === 'admin' ? '/admin' : '/portal'} replace />;
  }

  return <Outlet />;
}
